import { z } from 'zod';
import { RoleKey } from '../rbac';

export const loginSchema = z.object({
  email: z.string().email().toLowerCase().trim(),
  password: z.string().min(8).max(200),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const refreshSchema = z.object({
  refreshToken: z.string().min(10),
});
export type RefreshInput = z.infer<typeof refreshSchema>;

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(8).max(200),
    newPassword: z
      .string()
      .min(10, 'Mínimo de 10 caracteres')
      .max(200)
      .regex(/[a-z]/, 'Precisa de letra minúscula')
      .regex(/[A-Z]/, 'Precisa de letra maiúscula')
      .regex(/[0-9]/, 'Precisa de número'),
    confirmPassword: z.string(),
  })
  .refine((v) => v.newPassword === v.confirmPassword, {
    message: 'As senhas não conferem',
    path: ['confirmPassword'],
  });
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;

export const createUserSchema = z.object({
  name: z.string().trim().min(2).max(160),
  email: z.string().email().toLowerCase().trim(),
  password: z.string().min(10).max(200),
  roles: z.array(z.nativeEnum(RoleKey)).min(1),
  /** Obrigatório para papéis com escopo de cliente (CLIENT_VIEWER/CLIENT_APPROVER). */
  clientIds: z.array(z.string().uuid()).default([]),
  isActive: z.boolean().default(true),
});
export type CreateUserInput = z.infer<typeof createUserSchema>;

export const updateUserSchema = createUserSchema.partial().omit({ password: true });
export type UpdateUserInput = z.infer<typeof updateUserSchema>;

export interface AuthenticatedUser {
  id: string;
  organizationId: string;
  email: string;
  name: string;
  roles: RoleKey[];
  permissions: string[];
  /** null = acesso a todos os clientes da organização. */
  clientIds: string[] | null;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}

export interface LoginResponse extends AuthTokens {
  user: AuthenticatedUser;
}
